const getAllComponents = (model, result = []) => {
    result.push(model);
    model.components().each(mod => getAllComponents(mod, result))
    return result;
}

const  assignId = (component) => {
    component.addAttributes({id: component.ccid})        
}

function assignCompTypes(component){
    
    if (component.attributes.name === "Cell" || component.attributes.tagName === 'td' || component.attributes.tagName === 'th') {
        component.set('type', 'cell');
    } else if (component.attributes.name === "Row" || component.attributes.tagName === 'tr') {
        component.set('type', 'row');
    } else if (component.attributes.tagName === "nav"){
        component.set('type', 'nav');
    } else if (component.attributes.tagName === 'div' && component.attributes.type === '') {
        component.set('type', 'box');
    } else if (component.attributes.tagName === 'footer') {
        component.set('type', 'footer');
    } else if (component.attributes.tagName === 'p') {
        component.set('type', 'p');
    } else if (component.attributes.tagName === 'section') {
        component.set('type', 'section');
    } else if (component.attributes.tagName === 'li') {
        component.set('type', 'li');
    } else if (component.attributes.tagName === 'ol') {
        component.set('type', 'ol');
    } else if (component.attributes.tagName === 'ul') {
        component.set('type', 'ul');
    } else if (component.attributes.tagName === 'span'){
        component.set('type', 'text');
    }
}

const assignRule = (editor, component) => {
    const classes = component.getClasses();
    const newClassName = `classRule-${component.attributes.attributes.id}`;

    if(component.attributes.attributes.id === undefined || component.attributes.attributes.id === 'undefined'){
        return;
    }

    if(classes.includes(newClassName)===false){
        component.addClass(newClassName);
    } 
};

const assignAddRule = (editor, component) => {
    let pageName = '';
    const cssStyles = [];
    let onlyOneClass = true;
    const componentId = component.attributes.attributes.id;
    let oldId = '';
    const currentStyles = JSON.parse(localStorage.getItem('gjs-styles'));


    if (componentId === undefined) {
        return;
    }

    // Find the new class name and current page's name
    const newClassName = `classRule-${componentId}`;

    editor.StorageManager.load(['currentProject', 'currentPage'], (res) => {
        pageName = res.currentPage;
    });

    if(pageName === 'undefined' || pageName === undefined) {
        const selectedPageIndex = localStorage.getItem('selectedPage');
        const selectedProjectIndex = localStorage.getItem('selectedProject');
        pageName = JSON.parse(localStorage.getItem('data'))[selectedProjectIndex].pages[selectedPageIndex].name;
    }

    // Get the classes of the component
    const classes = component.getClasses();

    // If its an old project, return
    for(let i = 0 ; i< classes.length; i+= 1){
        if(classes[i].toLowerCase().endsWith(pageName.toLowerCase())){
            return;
        }
        if(classes[i].includes('classRule-')){
            if(classes[i] !== newClassName){
                // eslint-disable-next-line prefer-destructuring
                oldId = classes[i].split('-')[1];
                onlyOneClass = false;
            }
        }
    }

    if(onlyOneClass === true){
        return;
    }


    currentStyles.forEach((style) => {
        style.selectors.forEach((selector) => {
            if (typeof selector === 'string' && selector.startsWith(`classRule-${oldId}`)) {
                cssStyles.push(style.style);
            }
        });
    });

    // Add the new class
    if (classes.includes(newClassName) === false) {
        component.addClass(newClassName);
        classes.push(newClassName);
    }

    // Remove the old irrelevant classes
    for (let i = 0; i < classes.length; i += 1) {
        const className = classes[i];
        if (className.startsWith('classRule-')) {
            if (className !== newClassName) {
                component.removeClass(className);
                classes.splice(i, 1);
                i -= 1;
            }
        }
    }

    
    const compsClasses = [];

    // find the new class whole name
    let cssName = '';
    classes.forEach((classFound) => {
        compsClasses.push(classFound);
        cssName = `${cssName}.${classFound}`;
    });

    if (cssStyles.length === 0) {
        return;
    }

    // Add the new style to the local storage and to the css
    const newCreatedSelectors = [{ selectors: [compsClasses], style: cssStyles[0]}];
    localStorage.setItem('gjs-styles', JSON.stringify([...currentStyles,...newCreatedSelectors]));
    const css = editor.Css;
    css.setRule(cssName, cssStyles[0]);
};

const removeRule = (editor, component) => {
    // Get the classes of the component
    const classes = component.getClasses();

    let cssName = '';
    classes.forEach((classFound) => {
        cssName = `${cssName}.${classFound}`;
    });
    
    const cssComposer = editor.CssComposer;
    const toRemove = cssComposer.getRule(cssName);
    cssComposer.remove(toRemove);

};

const createRulesPerPage = (editor) => {
   
    editor.on('component:create', (component) => {

        if(editor.Commands.isActive('enable-navigate-page') === false){
            if(component.attributes.attributes.id === undefined && component.attributes.type !== 'textnode'){
                assignId(component);
                assignRule(editor, component);
                assignCompTypes(component);
            }
            else if (component.attributes.attributes.id !== undefined && component.attributes.type !== 'textnode'){
                assignRule( editor, component);
            }
        }
    })

    editor.on('component:remove', (component) => {
        removeRule(editor, component);
    })

    editor.on('component:create', (component) => {
        assignAddRule(editor, component);
    });
}

export {
    createRulesPerPage,
    getAllComponents
}